import React from 'react';
import PropTypes from 'prop-types';
import { ModalCloseButton } from 'ui-components/components/modal/modal-close-button';
import style from './print-modal-header.module.less';

export const PrintModalHeader = ({ closeModal, headerMessage }) => {
  return (
    <div className={style['print-modal-header']}>
      <div>{headerMessage}</div>
      <div className={style['close-button']}>
        <ModalCloseButton closeModal={closeModal} />
      </div>
    </div>
  );
};

PrintModalHeader.propTypes = {
  closeModal: PropTypes.func.isRequired,
  headerMessage: PropTypes.node.isRequired,
};
